module.exports = __webpack_public_path__ + "img/logo-um-fs.20c3341b.png";